import type { ReactNode } from 'react'
import { classes, getEnvString } from 'src/utils'
import HelpButton from './components/HelpButton'
import LoginButton from './components/LoginButton'

type Props = {
  title: string
  children?: ReactNode
  disableLogin?: boolean
  hideLogin?: boolean
  hideExtraRow?: boolean
  displayHelp?: boolean
}

export function Aside(props: Props) {
  return (
    <>
      <aside className="fixed top-0 left-0 right-0 z-10 w-screen border-b bg-slate-100 border-slate-200">
        <div className="relative z-20 flex flex-row items-center justify-center w-full h-16 max-w-[60rem] px-3 m-auto">
          <img
            src={require('src/images/logo_color_320.png')}
            height={48}
            width={48}
            alt="Mobile Connect"
            className="text-theme-500"
            title={getEnvString('REACT_APP_VERSION')}
          />
          <h1 className="ml-2 text-2xl text-slate-700 leading-[3rem] select-none">
            {props.title}
          </h1>

          <div className="flex-1" />

          {props.displayHelp && <HelpButton />}

          {!props.hideLogin && (
            <LoginButton
              disableLogin={props.disableLogin}
              displayHelp={props.displayHelp}
            />
          )}
        </div>

        {!props.hideExtraRow && (
          <nav className="w-full h-12 max-w-[60rem] mx-auto">
            {props.children}
          </nav>
        )}
      </aside>

      <div
        className={classes('relative', props.hideExtraRow ? 'h-16' : 'h-28')}
      />
    </>
  )
}
